import PropTypes from 'prop-types';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    typeof this.props.didCatch === 'function' && this.props.didCatch(error, errorInfo);
  }

  render() {
    const { children, fallback } = this.props;

    return this.state.hasError ? fallback : children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node.isRequired,
  didCatch: PropTypes.func,
};

export default ErrorBoundary;
